/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import LaneClosureRequestModule from './modules/LaneClosureRequestModule.js'
import VueGoogleMapsModule from './modules/VueGoogleMapsModule.js'
import {
	LaneClosureListModule
} from './modules/LaneClosureListModule.js'
import {
	ReportClosureListModule
} from './modules/ReportClosureListModule.js'
import {
	ReportRestrictionListModule
} from './modules/ReportRestrictionListModule.js'
import {
	ReportContraventionListModule
} from './modules/ReportContraventionListModule.js'
import {
	OrganizationListModule
} from './modules/OrganizationListModule.js'
import {
	UserListModule
} from './modules/UserListModule.js'
import {
	OrganizationTreeModule
} from './modules/OrganizationTreeModule.js'
import {
	OrganizationRequestListModule
} from './modules/OrganizationRequestListModule.js'
import {
	AppUserRequestListModule
} from './modules/AppUserRequestListModule.js'
import {
	NotificationScheduleListModule
} from './modules/NotificationScheduleListModule.js'
import {
	ProjectListModule
} from './modules/ProjectListModule.js'
import {
	AuditLogListModule
} from './modules/AuditLogListModule.js'
import {
	NotificationModule
} from './modules/NotificationModule.js'
import { AutoMessageModule } from './modules/AutoMessageModule.js'
import ErrorHandler from './utility/ErrorHandler';


Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		laneClosureRequest: LaneClosureRequestModule,
		laneClosureList: LaneClosureListModule,
		reportClosureList: ReportClosureListModule,
		reportRestrictionList: ReportRestrictionListModule,
		reportContraventionList: ReportContraventionListModule,
		organizationList: OrganizationListModule,
		userList: UserListModule,
		organizationTree: OrganizationTreeModule,
		map: VueGoogleMapsModule,
		autoMessages: AutoMessageModule,
		projectList: ProjectListModule,
		organizationRequestList: OrganizationRequestListModule,
		appUserRequestList: AppUserRequestListModule,
		notificationScheduleList: NotificationScheduleListModule,
		auditLogList: AuditLogListModule,
		notificationList: NotificationModule,
	},
	state: {
		buildVersion: process.env.VUE_APP_BUILD_VERSION,
		apiUrl: process.env.VUE_APP_API_URL,
		paidParkingLotMapUrl: process.env.VUE_APP_PAID_PARKING_STALLS_MAP_URL,
		googleMapUrl: process.env.VUE_APP_GOOGLE_MAP_URL,
		busStopMapUrl: process.env.VUE_APP_BUS_STOP_MAP_URL,
		streetApiUrl: process.env.VUE_APP_STREET_API_URL,
		swapUrl: process.env.VUE_APP_SWAP_URL,
		swapName: process.env.VUE_APP_SWAP_NAME,
		updateTotalInterval: 300 * 1000,
		status: '',
		token: localStorage.getItem('token') || '',
		user: null,
		transitionPeriod: false,
		transitionMessage: null,
		userAlternateContact: null,
		isMobile: true,
		userPermission: false,
		logoutRequested: false,
		goBackUrl: null,
		keyboardVisible: false,
		keyboardWillShow: false,
		keyboardHeight: null,
		deviceId: null,
	},
	mutations: {
		setDeviceId(state, deviceId) {
			// console.log("setDeviceId");
			// console.log(deviceId);
			state.deviceId = deviceId;
		},
		setKeyboardHeight(state, height) {
			state.keyboardHeight = height;
		},
		setKeyboardVisible(state, shown) {
			state.keyboardVisible = shown;
		},
		setKeyboardWillShow(state, shown) {
			state.keyboardWillShow = shown;
		},
		auth_request(state) {
			state.status = 'loading'
		},
		set_role(state, data) {
			state.userPermission = data[0].id;
		},
		auth_success(state, data) {
			state.status = 'success'
			state.token = data.token
			state.user = data.user
			state.transitionPeriod = data.showTransitionPeriod;
			state.transitionMessage = data.transitionMessage;
			state.userAlternateContact = data.userAlternateContact

			// if (typeof state.user.showMine == "undefined" || state.user.showMine == null) {
			// 	//
			// 	if (this.getters.userHasRole("internal_admin_requests") ||
			// 		this.getters.userHasRole("officer_requests") ||
			// 		this.getters.userHasRole("read_only") ||
			// 		this.getters.userHasRole("agency_admin")
			// 	) {
			// 		// show all requests
			// 		state.user.showMine = 0;
			// 	} else {
			// 		// only show mine.
			// 		state.user.showMine = 1;
			// 	}
			// }
			// apply the Show Mine filter if it isn't already set.
			let arg = "globalFilter";
			let argQuery = JSON.parse(localStorage.getItem(arg))
			if (argQuery == null) {
				argQuery = {};
			}
			if (typeof argQuery.showMine == "undefined") {
				if (this.getters.userHasRole("internal_admin_requests") ||
					this.getters.userHasRole("officer_requests") ||
					this.getters.userHasRole("read_only") ||
					this.getters.userHasRole("agency_admin")
				) {
					// show all requests
					state.user.showMine = 0;
				} else {
					// only show mine.
					state.user.showMine = 1;
				}
				argQuery.showMine = state.user.showMine;
				localStorage.setItem(arg, JSON.stringify(argQuery))
			}
		},
		aboutme_success(state, data) {
			state.status = 'success'
			state.user = data.user;
			state.transitionPeriod = data.showTransitionPeriod;
			state.transitionMessage = data.transitionMessage;
			state.userAlternateContact = data.userAlternateContact;

			if (typeof state.user.showMine == "undefined" || state.user.showMine == null) {
				//
				if (this.getters.userHasRole("internal_admin_requests") ||
					this.getters.userHasRole("officer_requests") ||
					this.getters.userHasRole("read_only") ||
					this.getters.userHasRole("agency_admin")
				) {
					// show all requests
					state.user.showMine = 0;
				} else {
					// only show mine.
					state.user.showMine = 1;
				}
			}
			if (state.user.showMine == null) {
				state.user.showMine = 1;
			}

			// apply the Show Mine filter if it isn't already set.
			let arg = "globalFilter";
			let argQuery = JSON.parse(localStorage.getItem(arg))
			if (argQuery == null) {
				argQuery = {};
			}
			if (typeof argQuery.showMine == "undefined") {
				argQuery.showMine = state.user.showMine;
				localStorage.setItem(arg, JSON.stringify(argQuery))
			}
		},
		aboutme_error(state) {
			state.status = 'error'
		},
		auth_error(state) {
			state.status = 'error'
		},
		logout(state) {
			state.status = ''
			state.token = ''
			state.user = null;
			state.logoutRequested = false;
		},
		logoutRequested(state, data) {
			state.logoutRequested = data;
		}
	},
	actions: {

		registerDeviceId({
			commit,
			dispatch
		}) {
			let that = this;
			// console.log("registerDeviceId");
			return new Promise((resolve, reject) => {
				// register it with the server...
				if (this.state.deviceId != null) {
					var platformId = Capacitor.getPlatform();
					// console.log(platformId);
					// console.log(this.state.deviceId);
					Vue.prototype.$http({
							url: this.state.apiUrl + '/user/register-device',
							data: {
								os: platformId,
								token: this.state.deviceId,
							},
							method: 'POST',
						})
						.then(resp => {
							// console.log("registerDeviceId response:");
							// console.log(resp);
							resolve(resp);
						})
						.catch(error => {
							// console.log("registerDeviceId error:");
							// console.log(error);
							reject(error)
						})
				}
			})
		},


		aboutMe({
			commit,
			dispatch
		}) {
			let that = this;
			let ts = new Date().getTime();
			return new Promise((resolve, reject) => {
				Vue.prototype.$http({
						url: this.state.apiUrl + '/user/about-me' + "?timestamp=" + ts,
						data: null,
						method: 'GET'
					})
					.then(resp => {
						if (resp) {
							if (resp.data) {
								if (resp.data.user) {
						const user = resp.data.user
						const userAlternateContact = resp.data.userAlternateContact
						user.permissions = resp.data.permissions;
						commit('aboutme_success', {
								user: user,
								userAlternateContact: userAlternateContact,
								transitionPeriod: resp.data.transitionPeriod,
								transitionMessage: resp.data.transitionMessage
							})
									// commit('set_role', user.roles);
						resolve(resp)
						Vue.prototype.startSignalR(that.state.token);
								} else {
									commit('aboutme_error')
									localStorage.removeItem('token')
									reject();
								}
							} else {
								commit('aboutme_error')
								localStorage.removeItem('token')
								reject();
							}
						} else {
							commit('aboutme_error')
							localStorage.removeItem('token')
							reject();
						}
					})
					.catch(error => {
						commit('aboutme_error')
						localStorage.removeItem('token')
						reject(error)
					}).finally(() => {
						// for push notifications if possible..
						dispatch('registerDeviceId').catch(function(error) {});
					})
			})
		},
		login({
			commit,
			dispatch
		}, user) {
			let that = this;
			let rememberMe = user.rememberMe
			delete user.rememberMe;
			let ts = new Date().getTime();

			return new Promise((resolve, reject) => {
				commit('auth_request')
				delete Vue.prototype.$http.defaults.headers.common['Authorization'];
				delete axios.defaults.headers.common['Authorization'];
				Vue.prototype.$http({
						url: this.state.apiUrl + '/login' + "?timestamp=" + ts,
						data: user,
						method: 'POST'
					})
					.then(resp => {
						const token = resp.data.token;
						const user = resp.data.user;
						const userAlternateContact = resp.data.userAlternateContact;

						user.permissions = resp.data.permissions;

						if (rememberMe) {
							let expireTime = new Date(Date.now() + 1000 * 3600 * 24 * 30) // One month
								// document.cookie = `tokenValid=true; expires=${expireTime.toUTCString()}; path=/`
							localStorage.setItem('tokenExpires', expireTime.toUTCString())
							localStorage.setItem('rememberMe', true);
						} else {
							// document.cookie = "tokenValid=true; path=/"
							localStorage.setItem('tokenExpires', null)
							localStorage.setItem('rememberMe', false);

						}
						if (localStorage.getItem('last_login') != user.userId) {
							dispatch('clearAllFilterParams')

						}
						localStorage.setItem('token', token)
						localStorage.setItem('last_login', user.userId)
						axios.defaults.headers.common['Authorization'] = "Bearer " + token
						Vue.prototype.$http.defaults.headers.common['Authorization'] = "Bearer " + token
						commit('auth_success', {
								token: token,
								user: user,
								userAlternateContact: userAlternateContact,
								transitionPeriod: resp.data.transitionPeriod,
								transitionMessage: resp.data.transitionMessage
							})
							// commit('set_role', user.roles)
						Vue.prototype.startSignalR(that.state.token);
						resolve(resp)
					})
					.catch(error => {
						// console.log("login error in store.js");
						// console.log(error);
						// console.log(typeof error);
						if (error) {
							commit('auth_error')
						}
						localStorage.removeItem('token')
						if (!ErrorHandler.HasLoginErrorCode(error) && !ErrorHandler.HasAccessErrorCode(error)) {
							Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
						}
						reject(error)
					}).finally(() => {
						// for push notifications if possible..
						dispatch('registerDeviceId').catch(function(error) {});
					})

			})
		},
		register({
			commit
		}, user) {
			let rememberMe = user.rememberMe
			delete user.rememberMe
			return new Promise((resolve, reject) => {
				commit('auth_request')
				Vue.prototype.$http({
						url: '${this.store.apiUrl}/register',
						data: user,
						method: 'POST'
					})
					.then(resp => {
						const token = resp.data.token
						const user = resp.data.user
						if (rememberMe) {
							let expireTime = new Date(Date.now() + 1000 * 3600 * 24 * 30) // One month
								// document.cookie = `tokenValid=true; expires=${expireTime.toUTCString()}; path=/`
							window.$cookies.set("tokenValid", true, expireTime.toUTCString(), "/");

						} else {
							window.$cookies.set("tokenValid", true, null, "/");
							// document.cookie = "tokenValid=true; path=/"
						}


						localStorage.setItem('token', token)
						Vue.prototype.$http.defaults.headers.common['Authorization'] = "Bearer " + token
						commit('auth_success', {
							token: token,
							user: user
						})
						resolve(resp)
					})
					.catch(error => {

						commit('auth_error', error)
						localStorage.removeItem('token')
						document.cookie = "tokenValid=false; path=/"
						reject(error)
					})
			})
		},
		logout({
			commit
		}) {
			return new Promise((resolve, reject) => {
				commit('logout')
				localStorage.removeItem('token')
				delete Vue.prototype.$http.defaults.headers.common['Authorization']
				let startOfTime = new Date(0)
					// document.cookie = `tokenValid=true; expires=${startOfTime.toString()}; path=/`
				window.$cookies.set("tokenValid", true, startOfTime.toUTCString(), "/");

				resolve()
				Vue.prototype.stopSignalR();
			})
		},
		clearAllFilterParams({
			dispatch
		}) {
			dispatch('laneClosureList/clearParams')
			dispatch('reportClosureList/clearParams')
			dispatch('reportRestrictionList/clearParams')
			dispatch('reportContraventionList/clearParams')
			dispatch('userList/clearParams')
			dispatch('organizationList/clearParams')
			dispatch('auditLogList/clearParams')

			localStorage.removeItem('lcrArgs')
			localStorage.removeItem('closureArgs')
			localStorage.removeItem('restrictionArgs')
			localStorage.removeItem('contraventionArgs')
			localStorage.removeItem('userArgs')
			localStorage.removeItem('organizationArgs')
			localStorage.removeItem('auditLogArgs')
			localStorage.removeItem('globalFilter')

			// For editing user and org
			localStorage.removeItem('editingParentOrganizationId')
		}
	},
	getters: {
		keyboardVisible: state => state.keyboardVisible,
		keyboardWillShow: state => state.keyboardWillShow,
		keyboardHeight: state => state.keyboardHeight,
		isLoggedIn: state => !!state.token,
		isReadOnly: (state, getters) => () => {
			if (getters.userHasRole('read_only')) {
				return true;
			}
			return false;
		},

		userCanCreateRequest: (state, getters) => () => {
			// The user might have other permissions.
			if (getters.userHasPermission('lcr_update_org') || getters.userHasPermission('lcr_update_mine') || getters.userHasPermission('lcr_update_all')) {
				return true;
			}
			return true;
		},

		tokenValid: state => () => {
			if (localStorage.getItem('token') != "") {
				return true;
			}
			// this doesn't work in safari for some reason.
			// console.log("window.$cookies.get('tokenValid'):" + window.$cookies.get('tokenValid'));
			if (window.$cookies.isKey('tokenValid')) {
				if (window.$cookies.get('tokenValid') == "true") {
					return true;
				}
			}
			return false;
		},

		authStatus: state => state.status,
		userId: state => () => {
			if (state.user) {
				return state.user.userId;
			}
		},
		userInfo: state => () => {
			return state.user;
		},
		userAlternateContact: state => () => {
			return state.userAlternateContact;
		},

		userHasRole: state => (role) => {
			if (state.user) {
				let x = 0;
				if (state.user.roles) {
					for (x = 0; x < state.user.roles.length; x++) {
						if (state.user.roles[x].id == role) {
							return true;
						}
					}
				}
			}
			return false;
		},

		userHasPermission: state => (permission) => {
			if (state.user) {
				let x = 0;
				if (state.user.permissions) {
					for (x = 0; x < state.user.permissions.length; x++) {
						if (state.user.permissions[x] == permission) {
							return true;
						}
					}
				}
			}
			return false;
		},


		userIsReadOnly: (state, getters) => () => {
			if (getters.userHasRole('read_only')) {
				return true;
			}
			return false;
		},

		userCanReportContravention: (state, getters) => () => {
			if (getters.userHasRole('officer_requests') || getters.userHasRole('internal_admin_requests')) {
				return true;
			}
			return false;
		},


		userCanSetTrafficEffect: (state, getters) => () => {
			if (getters.userHasRole('internal_admin_requests')) {
				return true;
			}
			return false;
		},

		canEditUserInOrganization: state => (organizationId, organizations) => {
			let editUserInOrg = false;
			let userInOrgTree = false;
			if (organizations) {
				for (let x = 0; x < organizations.length; x++) {
					if (organizationId == organizations[x].id) {
						editUserInOrg = true;
					}
					if (state.user.organizationId == organizations[x].id) {
						userInOrgTree = true;
					}
				}
				if (editUserInOrg == true && userInOrgTree == true) {
					return true;
				}
			}
			return false;
		},

		logoutRequested: state => {
			return state.logoutRequested;
		}
	}
})